import {Component, Inject, OnInit} from '@angular/core';
import {MatSelectChange} from "@angular/material/select";
import {Observable} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {CounselingService} from "../../counseling.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AddGroupSessionComponent, CentreSelection} from "../add-group-session/add-group-session.component";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../../services/log.service";
import {Subject} from "rxjs/internal/Subject";
import {GlossaryService} from "../../../../components/glossary/glossary.service";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {AngularFireDatabase} from "@angular/fire/compat/database";

@Component({
  selector: 'app-edit-group-counseling',
  templateUrl: './edit-group-counseling.component.html',
  styleUrls: ['./edit-group-counseling.component.scss']
})
export class EditGroupCounselingComponent implements OnInit {
  types=["Admission Counselling","Regular Counselling","Follow Up Counselling","Discharge Counselling","Others"]



  centres$: Observable<Centre[]>
  form: FormGroup
  selectedChildrens?:any[]
  parents?:string[]
  children$?: Observable<FullChild[]>

  startTime: any
  endTime: any
  centreSelect = new FormControl('', [Validators.required]);
  childSelect = new FormControl('', [Validators.required]);
  mGlossaryData:any
  destroyed$ = new Subject()
  _topiceCovered$: Observable<String[]>;


  constructor(private centreService: CentreService,
              private childService: ChildService,
              private counsellingService: CounselingService,
              private _snackBar: MatSnackBar,
              private readonly mLogService:LogService,
              private readonly mGlossary: GlossaryService,
              private readonly mDatabase:AngularFireDatabase,

              @Inject(MAT_DIALOG_DATA) public data: any,
              private readonly matDialogRef:MatDialogRef<AddGroupSessionComponent>
              // private dialogRef:MatDialogRef<AddGroupSessionComponent>
  ) {
    this.centres$ = this.centreService.getAllCentres()
    // alert(this.data.children.length)
    this.form = new FormGroup({
      // centreName: new FormControl('', Validators.required),
      centres: new FormControl(this.getCentresName(this.data.centres), Validators.required),
      // parents: new FormControl(this.parents, Validators.required),
      children: new FormControl(this.getChildNames(this.data.children), Validators.required),
      // childCodes: new FormControl('', Validators.required),
      startTime: new FormControl(this.checkDate((this.data?.startTime)), Validators.required),
      endTime: new FormControl(this.checkDate((this.data?.endTime)), Validators.required),
      date: new FormControl(this.checkDate((this.data?.date)), Validators.required),
      // description: new FormControl('', Validators.required),
      participants: new FormControl(this.data.participants, Validators.required),
      topicsCovered: new FormControl(this.data.topicsCovered, Validators.required),
      issue: new FormControl(this.data.issue, Validators.required),
      intervention: new FormControl(this.data.intervention,),
      takeaway: new FormControl(this.data.takeaway, Validators.required),
      // type: new FormControl('', Validators.required),
      // createdAt: new FormControl(''),
      updatedAt: new FormControl(new Date()),

      // childCode:new FormControl('',Validators.required),
    })
    this.form.get('centres')?.disable()
    this.form.get('children')?.disable()
    this._topiceCovered$ = this.mDatabase.list<String>('types/Topics Covered').valueChanges()

  }
  ngOnInit(): void {
    this.mGlossary.fetchCounsellingGlossary().pipe(takeUntil(this.destroyed$)).subscribe(res=>{

      this.mGlossaryData  =res
    })
  }
  fetchChildren($event: MatSelectChange) {
    let centres = $event.value as CentreSelection[]
    let centreCodes: String[] = []
    let centreNames: String[] = []
    let allcentres:any[]=[]
    centres.forEach(v => {
      centreCodes.push(v.centreCode)
      centreNames.push(v.centreName)
      allcentres.push({
        centreName:v.centreName,
        centreCode:v.centreCode
      })
    })

    console.log(centreCodes)
    console.log(centreNames)
    // alert(centre)
    this.children$ = this.childService.getAllotedChildListByCenterarray(centreCodes)
    this.form.get('centres')?.setValue(allcentres)
    // this.form.get('centreCode')?.setValue(centres.centreCode)
  }

  onChildSelect($event: MatSelectChange) {
    let children = $event.value as FullChild[]
    let childrens: any[] = []
    let childNames: String[] = []
    children.forEach(v => {
      childrens.push({
        'childCode': v.childCode,
        'childName': v.firstName +' '+ v.lastName,
        'parentsName':v.guardians[0]?.firstName +'and '+v.guardians[1]?.firstName,
      })
      childNames.push(v.firstName + " " + v.lastName)
      // let p = (v.guardians[0]?.firstName +' and '+v.guardians[1]?.firstName).toString()
      // console.log('p',p)
      // this.parents?.push(p)
      // console.log(this.parents)
    })

    // this.form.get('childCodes')?.setValue(childCodes)
    this.form.get('childNames')?.setValue(childNames)
    this.form.get('children')?.setValue(childrens)
    // @ts-ignore
    this.selectedChildrens = childrens
  }

  Submit() {

    if (this.form.valid) {
      // this.form.removeControl('children')
      // this.form.removeControl('centres')
      this.counsellingService.editGroupSession(this.form.value,this.data.id).then(() => {
        this._snackBar.open('Session Submitted')._dismissAfter(3000)
        let activity={
          date:new Date().getTime(),
          section: 'Group Counseling',
          action: 'Update',

          description: `Session updated in Counseling by user ${this.form.get('childNames')} ${this.form.get('childCode')}` ,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
        this.matDialogRef.close()
      })
    } else {
      this._snackBar.open('Please enter the form carefully')._dismissAfter(3000)
      console.log(this.findInvalidControls())
    }

  }

  private getCentresName(centres: { centreName: string; }[]) {
    let centresName=''
    centres.forEach((it: { centreName: string; })=>{
      centresName += it.centreName+''
    })
    return centresName;
  }
  private getChildNames(children:any[]) {
    let centresName=''
    children.forEach((it:any)=>{
      centresName += it.childName+''
    })
    return centresName;
  }


  private checkDate(date: any) {
    let d:any=''
    if(date!=null){
      d=(date as Timestamp).toDate()
    }
    else d=null
    return d

  }

  Cancel() {
    this.matDialogRef.close()
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
}
